export default [
  'coy',
  'dark',
  'funky',
  'okaidia',
  'solarizedlight',
  'tomorrow',
  'twilight',
  'prism',
  'a11y-dark',
  'atom-dark',
  'base16-ateliersulphurpool.light',
  'cb',
  'coldark-cold',
  'coldark-dark',
  'coy-without-shadows',
  'darcula',
  'dracula',
  'duotone-dark',
  'duotone-earth',
  'duotone-forest',
  'duotone-light',
  'duotone-sea',
  'duotone-space',
  'ghcolors',
  'gruvbox-dark',
  'gruvbox-light',
  'holi-theme',
  'hopscotch',
  'lucario',
  'material-dark',
  'material-light',
  'material-oceanic',
  'night-owl',
  'nord',
  'one-dark',
  'one-light',
  'pojoaque',
  'shades-of-purple',
  'solarized-dark-atom',
  'synthwave84',
  'vs',
  'vsc-dark-plus',
  'xonokai',
  'z-touch'
]
